'use strict';

const runTransitionsSetup = (
	$window,
	$document,
	$transitions,
	pmtVersionCheck,
	pmtAccessService,
	auth,
	pmtLightBoxBodyClassesService
) => {
	$transitions.onSuccess({}, function (transition) {
		if (transition.to().name !== transition.from().name) {
			$document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
		}
	});

	$transitions.onBefore({}, function () {
		if (!pmtVersionCheck.isCurrentVersion) {
			$window.location.reload();
		}
	});

	$transitions.onBefore({}, function (transition) {
		pmtLightBoxBodyClassesService.resetClasses();
		if (transition.to().requiredPermission && transition.params().site) {
			const siteName = transition.params().site;
			const forceRefresh = transition.params().forceRefresh;
			const getUserMethod = forceRefresh === '1' ? auth.forceReloadUser : auth.getUser;

			return getUserMethod(siteName)
				.then(function () {
					return pmtAccessService.checkPermission(transition.to().requiredPermission, siteName);
				})
				.catch(function () {
					return transition.router.stateService.target('site.NoPermissions', {
						site: siteName
					});
				});
		} else if (transition.params().site) {
			const siteName = transition.params().site;
			const forceRefresh = transition.params().forceRefresh;
			const getUserMethod = forceRefresh === '1' ? auth.forceReloadUser : auth.getUser;

			return getUserMethod(siteName).catch(function () {
				return transition.router.stateService.target('SwitchAccounts');
			});
		}
	});
};

module.exports = {
	runTransitionsSetup
};
